import * as apiSW from 'api/menu/GetMenuStartingWithV1';
import Menu from 'classes/_general/Search/Menu/Menu';
import { ISelectItem } from 'interfaces/ISelectItem';

export default class MenuList {
	public all: Menu[] = [];
	public filtered: ISelectItem[] = [];

	public async initialize(): Promise<void> {
		const response = await apiSW.callApi('', false);
		response.hasValue() && this.mapFromApi(response.get());
	}

	public async search(searchTerm: string): Promise<void> {
		const filtered: Menu[] = this.all.filter((e: Menu) =>
			e.description.toLowerCase().startsWith(searchTerm.toLowerCase())
		);
		this.filtered = this.mapToSelectItems(filtered);
	}

	public getById(id: string): Menu | undefined {
		return this.all.find((e: Menu) => {
			return e.id === id;
		});
	}

	private mapToSelectItems(input: Menu[]): ISelectItem[] {
		return input.map((e: Menu) => {
			return e.mapToSelectItem();
		});
	}

	private mapFromApi(input: apiSW.ResponseMenu[]): void {
		this.all = [];
		for (const i of input) {
			const recipe: Menu = new Menu(i);
			this.all.push(recipe);
		}
	}
}
